export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11405.f22915a9.jpg";